import {useSuspenseQuery} from '@tanstack/react-query';
import {prepareSearchParams} from 'shared';

import {api} from '@/lib/ky';

import {categoryPresetSchema} from '../utils/schemas/categoryPreset';

import {categoryPresetKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getCategoryPresets = async (params: QueryParams = {}) => {
  const data = await api
    .get(`categorypresets`, {searchParams: prepareSearchParams(params)})
    .json();
  return categoryPresetSchema.array().parse(data);
};

export const useCategoryPresets = (config?: QueryConfig<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: categoryPresetKeys.lists(),
    queryFn: () => getCategoryPresets(),
  });
};
export const useCategoryPresetsLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getCategoryPresets;
type QueryParams = Parameters<typeof categoryPresetKeys.list>[0];
